import React from 'react';
import withStyles from '@mui/styles/withStyles';
import {Box, Typography, Link} from '@mui/material';
import check from '../../assets/images/check.png';
import circle from "../../assets/images/circle_icon.png"

const styles = theme => ({
  root: {
    marginBottom: 5,
    textDecoration: 'none',
  },
  heading: {
    color: '#000',
    fontWeight: 200,
    fontSize: 16,
    marginBottom: 20,
  },
  links: {
    color: '#000',
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 2,
  },
  image: {
    height: 20,
    marginRight: 20,
  },
  accepted: {
    fontSize: 12,
    color: '#BEBEBE',
  },
});

const ApprovalBox = ({classes, text, link, target, accepted, onAccept}) => {
  const image = accepted ? check : circle;

  const handleCheckboxClick = (e) => {
    onAccept(!accepted); 
  };

  return (
    <Box display="flex" alignItems="center" className={classes.root}>
      <Box onClick={handleCheckboxClick} className={classes.checkbox}>
        <img src={image} className={classes.image} alt="rule icon" />
      </Box>
      <Link target={target} href={link} className={classes.link}>
        <Box display="flex" flexDirection="column">
          <Typography gutterBottom variant="h6" className={classes.links}>
            {text}
          </Typography>
          {accepted && (
            <Typography gutterBottom variant="h6" className={classes.accepted}>
              Akzeptiert
            </Typography>
          )}
        </Box>
      </Link>
    </Box>
  );
};

export default withStyles(styles)(ApprovalBox);
